import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const March = () => {
    return (
        <Fragment>{SkipDays(7, 2, [], true)}</Fragment>  
    )
}